<template>
  <v-dialog :value="true" max-width="500" persistent>
    <v-card>
      <v-card-title>{{ resx.labels.tags }} — {{ obligation.name }}</v-card-title>
      <v-card-text>
        <tag-select v-model="selected" :items="tags" :label="resx.labels.tags" :loading="loading" />
        <!-- Sin etiquetas cargadas el desplegable sale vacio y parece roto: se
             dice por que y que hacer. Las etiquetas se crean en la pantalla
             Etiquetas del menu. -->
        <div v-if="!loading && !tags.length" class="caption grey--text text--darken-1 mt-n2 mb-2">
          No hay etiquetas creadas. Ingrese una manualmente para comenzar a etiquetar.
        </div>
        <v-alert v-if="errorMessage" type="error" dense text>{{ errorMessage }}</v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn :disabled="saving" @click="$emit('close')">{{ resx.labels.cancel }}</v-btn>
        <v-btn class="primary" :loading="saving" @click="save">{{ resx.labels.ok }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
"use strict";

import tagsService from "@/services/TagsService";
import tagSelect from "@/components/common/tag-select.component.vue";
import contractorCompanyService from "@/services/ContractorCompanyService";

export default {
  name: "obligation-tags-dialog",
  components: { tagSelect },
  props: {
    obligation: { type: Object, required: true },
    contractorCompanyId: { type: String, required: true }
  },
  data() {
    return { tags: [], selected: [], loading: false, saving: false, errorMessage: null };
  },
  async mounted() {
    this.loading = true;
    try {
      this.tags = await tagsService.list();
      // Las etiquetas llegan como ids o como objetos segun si el backend
      // populo. El v-autocomplete trabaja con ids.
      this.selected = (this.obligation.tags || []).map(t =>
        typeof t === "string" ? t : t._id
      );
    } catch (error) {
      this.errorMessage = this.messageOf(error, "No se pudieron cargar las etiquetas");
    } finally {
      this.loading = false;
    }
  },
  methods: {
    messageOf(error, fallback) {
      return (error.response && error.response.data && error.response.data.message) || fallback;
    },
    async save() {
      if (this.saving) return;
      this.errorMessage = null;
      this.saving = true;
      try {
        await contractorCompanyService.setObligationTags(
          this.contractorCompanyId,
          this.obligation,
          this.selected
        );
        this.$emit("saved", this.selected);
        this.$emit("close");
      } catch (error) {
        this.errorMessage = this.messageOf(error, "No se pudieron guardar las etiquetas");
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>
